import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpClientModule,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import {
  CompanyInformation,
  MandatoryDocuments,
} from "../models/myProfile.model";
import { BuildEnvironment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class MyProfileService {
  private baseurl: string;

  constructor(private http: HttpClient) {
    let rootURL = BuildEnvironment.GetEnvironmentUrl();
    this.baseurl = rootURL;
  }

  // getAgencyInformation(agentId): Observable<any> {
  //   return this.http.get(
  //     this.baseurl + "/myprofile/agencyinformation/" + agentId
  //   );
  // }

  getAgencyInformation(agencyId: string): Observable<any> {
    return this.http.get(
      this.baseurl + "/myprofile/companyinformation/" + agencyId
    );
  }

  getAgencyOnboardingStatus(agencyId): Observable<any> {
    return this.http.get(
      this.baseurl + "/myprofile/onboarding/getOnboardingSteps/" + agencyId
    );
  }

  updateAgencyOnboardingStatus(
    agencyId: number,
    status: string,
    stepName: string
  ): Observable<any> {
    return this.http.post(
      this.baseurl + "/myprofile/onboarding/updateOnboardingSteps/" + agencyId,
      {
        status: status,
        stepName: stepName,
      }
    );
  }

  insertAgencyInformation(formdata, agencyId): Observable<any> {
    return this.http.post(
      this.baseurl + "/myprofile/companyinformation/insert/" + agencyId,
      formdata
    );
  }

  updateAgencyInformation(formdata, agencyId): Observable<any> {
    console.log("Form Data: ", formdata);
    return this.http.post(
      this.baseurl + "/myprofile/companyinformation/update/" + agencyId,
      formdata
    );
  }

  getAgentProfileById(oid): Observable<CompanyInformation> {
    return this.http.get<CompanyInformation>(
      //This route may need to change
      this.baseurl + "/myprofile/companyinformation/" + oid
    );
    // try {
    //   return this.http.get<ICompanyInformation>(
    //     //This route may need to change
    //     this.baseurl + "/myprofile/companyinformation/" + agentid
    //   );
    // } catch (err) {
    //   console.log("---------Unexpected error occured-------");
    // }
  }

  updateAgentProfile(formdata, agentid): Observable<CompanyInformation> {
    return this.http.post<CompanyInformation>(
      //This route may need to change
      this.baseurl + "/myprofile/companyinformation/update/" + agentid,
      formdata
    );
  }

  getMandatoryDocs(agentid): Observable<MandatoryDocuments[]> {
    return this.http.get<MandatoryDocuments[]>(
      this.baseurl + "/myprofile/mandatorydocuments/" + agentid
    );
  }

  uploadMandatoryDocs(
    files: MandatoryDocuments[],
    agentId: number,
    toBeDeleted: MandatoryDocuments[]
  ): Observable<any> {
    //console.log(toBeDeleted);
    return this.http.put(
      this.baseurl + "/myprofile/mandatorydocuments/update/" + agentId,
      {
        documentList: files,
        toBeDeleted: toBeDeleted,
      }
    );
  }

  public getFormData(object) {
    console.log("Object in getFormData: ", object);
    const formData = new FormData();
    Object.keys(object).forEach((key) => {
      console.log("Key: ", key);
      console.log("Value: ", object[key]);
      formData.append(key, object[key] ? object[key] : "");
    });
    console.log("Form Data getting returned from getFormData: ", formData);
    return formData;
  }

  insertProfilePic(data: any, agentId: number, file: any): Observable<any> {
    console.log("Data: ", data);
    console.log("Agent ID: ", agentId);
    const formData = new FormData();

    // Check if data exists before trying to use Object.keys()
    if (data) {
      Object.keys(data).forEach((key) => {
        const value = data[key];
        console.log(`Appending key: ${key}, value: ${value}`);
        formData.append(key, value ? value : "");
      });
    }
    console.log("Form Data: ", formData);
    if (file) {
      formData.append("file", file, data?.newImgFileName || "image");
    }
    return this.http.post(
      this.baseurl + "/myprofile/onboarding/insertAgentPic/" + agentId,
      formData
    );
  }

  insertOnboardingInfo(data: any, agencyId: number): Observable<any> {
    console.log("insertOnboardingInfo Data: ", data);

    try {
      return this.http.post(
        this.baseurl + "/myprofile/onboarding/insert/" + agencyId,
        data
      );
    } catch (error) {
      console.error("Error in insertOnboardingInfo: ", error);
      throw error;
    }
  }

  uploadFile(fd: FormData, agentId: number): Observable<any> {
    return this.http.put(
      this.baseurl + "/myprofile/mandatorydocuments/upload/" + agentId,
      fd
    );
  }

  getAllCountryList(): Observable<any> {
    return this.http.get(this.baseurl + "/lookups/tables/country");
  }

  downloadFile(agentId: number, filename: string): Observable<any> {
    return this.http.get(
      this.baseurl +
        `/myprofile/mandatorydocuments/download/` +
        agentId +
        "/" +
        filename,
      { responseType: "blob" }
    );
  }

  deleteMandatoryDocs(
    agentid: number,
    docid: number
  ): Observable<MandatoryDocuments> {
    return this.http.delete<MandatoryDocuments>(
      this.baseurl +
        "/myprofile/mandatorydocuments/delete/" +
        agentid +
        "/" +
        docid
    );
  }
}
